import { render, staticRenderFns } from "./_Instrucao.vue?vue&type=template&id=3f5533e4&scoped=true&"
import script from "./_Instrucao.vue?vue&type=script&lang=js&"
export * from "./_Instrucao.vue?vue&type=script&lang=js&"
import style0 from "./_Instrucao.vue?vue&type=style&index=0&id=3f5533e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5533e4",
  null
  
)

export default component.exports